<template>
  <div class="">
    <div class="d-flex flex-row align-center justify-space-between mb-4">
      <div class="top-header mb-0">Subscription by Phone</div>
    </div>

    <v-alert v-model="errorAlert" dismissible dense outlined type="error">
      <span> {{ errorMsg }} </span>
    </v-alert>

    <div class="d-flex flex-row align-center justify-space-between mb-5">
      <div class="d-flex flex-row align-center">
        <v-text-field
          v-model="qSearch"
          solo
          dense
          flat
          style="max-width: 250px; border-radius: 8px"
          hide-details
          :label="$t('SearchAccounts') + '...'"
          @keydown.enter="getPhones()"
        >
          <img
            slot="prepend-inner"
            width="20px"
            height="20px"
            src="/icons/search.svg"
          />
        </v-text-field>

        <v-btn
          depressed
          tile
          class="text-capitalize white--text ml-5"
          color="#0F52BC"
          @click="getPhones()"
        >
          <img width="32px" height="32px" src="/icons/reload.svg" />
          {{ $t("Reload") }}
        </v-btn>
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="clients"
      :options.sync="options"
      :server-items-length="totalClients"
      :loading="loadingTable"
      :loading-text="`${$t('Loading')}... ${$t('PleaseWait')}`"
      :footer-props="footerProps"
    >
    </v-data-table>
  </div>
</template>

<script>
import RestResourceClient from "@/api/apiClientService";
import { ResponseStatus } from "@/models/ResponseStatusEnum";
import { Permission } from "@/utils/permissions";
import { permissionMixin } from "@/utils/mixins";
import { vdataTable } from "@/plugins/vuetify-custom-props";
import RestResourceSms from "../../api/apiSmsService";
import RestResourceUser from "../../api/apiUserService";
export default {
  name: "ClientList",
  mixins: [permissionMixin],
  data() {
    return {
      loadingTable: false,
      clients: [],
      options: {},
      footerProps: {
        ...vdataTable.footerProps,
        prevIcon: "mdi-chevron-left orange--text text--darken-2",
        nextIcon: "mdi-chevron-right orange--text text--darken-2"
      },
      totalClients: 0,
      answerDialog: false,
      answerDialogEmail: false,
      changePasswordDialog: false,
      answerText: null,
      answerEmail: null,
      sending: false,
      qSearch: "",
      StripeTerminal: null,
      errorAlert: false,
      errorMsg: "",
      terminal: null,
      filterParams: {
        name: null,
        email: null,
        phone: null,
        role: "Client",
        created: true
      },
      selectedUser: {
        _id: "",
        phone: "",
        email: ""
      },
      userDefault: {
        _id: "",
        phone: "",
        email: ""
      },
      headers: [
        {
          align: "start",
          sortable: false,
          width: 100,
          value: "edit"
        },
        { text: "Phone", value: "phone", sortable: false },
        {
          text: "Register date",
          value: "createdAt",
          sortable: false,
          float: "right"
        },
        {
          text: "Options",
          sortable: false,
          align: "end",
          value: "answer"
        }
      ],
      newPassword: "",
      verifyPassword: ""
    };
  },
  watch: {
    options: {
      handler() {
        this.getPhones();
      },
      deep: true
    }
  },
  computed: {
    detailsPencilPerms() {
      return [Permission.LIST_CLIENT];
    },
    answerPerms() {
      return [Permission.CONTACT_USER];
    },
    passwordMatch() {
      return () =>
        this.newPassword === this.verifyPassword ||
        this.$t("errors.passMustMatch");
    }
  },
  methods: {
    async getPhones() {
      if (this.qSearch.length >= 1 && this.qSearch.length <= 2) {
        this.errorAlert = true;
        this.errorMsg = "The search must have 3 or more characters.";
        return;
      }
      this.loadingTable = true;
      RestResourceClient.prototype
        .getPhones(this.getParams())
        .then(async response => {
          if (response.status === ResponseStatus.OK) {
            this.totalClients = response.data.total;
            this.clients = response.data.data;
            console.log(this.clients);
            this.clients.map(client => {
              client.fullName = client.name + " " + client.lastName;
            });
            this.clients.forEach((client, index) => {
              this.clients[index].createdAt = this.clients[index].createdAt
                .split("T")
                .join(" ")
                .split("-")
                .join("/")
                .split(".")[0];
            });
          }
        })
        .catch(error => {
          this.errorAlert = true;
          this.errorMsg = error.response.data.message;
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },
    goToClient(client) {
      this.$router.push({
        name: "clientId",
        params: { id: client._id }
      });
    },
    openDialog(item) {
      this.selectedUser = Object.assign({}, item);
      this.answerDialog = true;
    },
    openDialogEmail(item) {
      this.selectedUser = Object.assign({}, item);
      this.answerDialogEmail = true;
    },
    openDialogChangePassword(item) {
      this.selectedUser = Object.assign({}, item);
      this.changePasswordDialog = true;
    },
    closeAnswerDialog() {
      setTimeout(() => {
        this.selectedUser = Object.assign({}, this.userDefault);
        this.answerText = "";
        this.$refs.form.reset();
      }, 500);
      this.answerDialog = false;
    },
    closeAnswerDialogEmail() {
      setTimeout(() => {
        this.selectedUser = Object.assign({}, this.userDefault);
        this.answerEmail = "";
        this.$refs.form.reset();
      }, 500);
      this.answerDialogEmail = false;
    },
    closeChangePasswordDialog() {
      setTimeout(() => {
        this.selectedUser = Object.assign({}, this.userDefault);
        this.newPassword = "";
        this.verifyPassword = "";
        this.$refs.form.reset();
      }, 500);
      this.changePasswordDialog = false;
    },
    async sendAnswer() {
      if (!this.$refs.form.validate()) return;
      try {
        this.sending = true;
        await RestResourceSms.prototype.sendSmsToUser({
          email: this.selectedUser.email,
          body: this.answerText
        });
        this.closeAnswerDialog();
      } catch (error) {
        this.errorAlert = true;
        this.errorMsg = error.response.data.message;
        this.closeAnswerDialog();
      } finally {
        this.sending = false;
      }
    },
    async sendAnswerEmail() {
      if (!this.$refs.form.validate()) return;
      try {
        this.sending = true;
        await RestResourceSms.prototype.sendEmailToUser({
          userId: this.selectedUser._id,
          body: this.answerEmail
        });
        this.closeAnswerDialogEmail();
      } catch (error) {
        this.errorAlert = true;
        this.errorMsg = error.response.data.message;
        this.closeAnswerDialogEmail();
      } finally {
        this.sending = false;
      }
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      let params = {
        q: this.qSearch || null,
        skip: (page - 1) * itemsPerPage,
        limit: itemsPerPage
      };
      params = { ...params, ...this.filterParams };
      return params;
    },
    async changePassword() {
      try {
        this.sending = true;
        await RestResourceUser.prototype.changeUserPassword({
          newPassword: this.newPassword,
          verifyPassword: this.verifyPassword,
          userId: this.selectedUser._id,
          userRole: this.selectedUser.role
        });
        this.closeChangePasswordDialog();
      } catch (e) {
        this.errorAlert = true;
        this.errorMsg = e.response.data.message;
        this.closeChangePasswordDialog();
      } finally {
        this.sending = false;
      }
    },
    goToCreate() {
      this.$router.push({ name: "new_client" });
    }
  }
};
</script>

<style>
.client-filter-input >>> .v-input__slot {
  min-height: 30px !important;
  height: 30px !important;
  font-size: 1rem !important;
  font-weight: 200;
}
.client-filter-input >>> .v-select__slot .v-input__append-inner {
  margin-top: 5px !important;
}
.client-filter-input >>> .v-select__selections {
  font-size: 12px;
}
</style>
